import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { systemConfigAPI } from '../services/api';
import { setLocaleSettings, getLocaleSettings, DEFAULT_LOCALE_SETTINGS } from '../utils/localeFormat';

const LocaleContext = createContext({
  localeSettings: DEFAULT_LOCALE_SETTINGS,
  localeLoading: true,
  refreshLocaleSettings: async () => {}
});

export const LocaleProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [localeSettings, setLocaleSettingsState] = useState(() => getLocaleSettings());
  const [localeLoading, setLocaleLoading] = useState(true);

  const refreshLocaleSettings = useCallback(async () => {
    if (!user) {
      setLocaleSettings(DEFAULT_LOCALE_SETTINGS);
      setLocaleSettingsState({ ...DEFAULT_LOCALE_SETTINGS });
      setLocaleLoading(false);
      return;
    }
    try {
      setLocaleLoading(true);
      const res = await systemConfigAPI.getLocale();
      const locale = res?.data?.locale || DEFAULT_LOCALE_SETTINGS;
      setLocaleSettings(locale);
      setLocaleSettingsState({ ...locale });
    } catch {
      setLocaleSettings(DEFAULT_LOCALE_SETTINGS);
      setLocaleSettingsState({ ...DEFAULT_LOCALE_SETTINGS });
    } finally {
      setLocaleLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (authLoading) return;
    refreshLocaleSettings();
  }, [authLoading, user?.id, refreshLocaleSettings]);

  return (
    <LocaleContext.Provider value={{ localeSettings, localeLoading, refreshLocaleSettings }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);
